import React, { useEffect, useState } from 'react';

import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import DatePickerField from '../../formFields/datePickerField';

import DownloadIcon from '@mui/icons-material/Download';
import { useFormikContext } from 'formik';

export const ExportControlTiempos = (props: any) => {
  // USE FORMIK CONTEXT
  const formikProps: any = useFormikContext();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [reportFormat, setReportFormat] = useState<'excel' | 'pdf'>('excel');
  const [reportType, setReportType] = useState({
    excel: true,
    pdf: false,
  });
  const [isGenerating, setIsGenerating] = useState(false);

  const {
    formField: { from, to },
  } = props;

  useEffect(() => {
    formikProps.setFieldValue('format', reportFormat);
  }, []);

  const handleReportTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name as 'excel' | 'pdf';

    // Si el checkbox que se está clickeando ya está activado, no hacer nada
    if (reportType[name]) return;

    // Crear un nuevo objeto donde solo el checkbox clickeado esté en true
    setReportType({
      excel: name === 'excel',
      pdf: name === 'pdf',
    });

    formikProps.setFieldValue('format', name);
  };

  const handleGenerateReport = async () => {
    setIsGenerating(true);

    try {
      // Aquí iría la lógica para generar el reporte
      console.log('Generando reporte:', {
        startDate,
        endDate,
        reportType,
      });

      // Simulamos una demora de red
      await new Promise((resolve) => setTimeout(resolve, 1500));

      alert(
        `Reporte ${reportType.excel ? 'Excel' : 'PDF'} generado para el período ${startDate?.toLocaleDateString()} - ${endDate?.toLocaleDateString()}`
      );
    } catch (error) {
      console.error('Error generando reporte:', error);
      alert('Ocurrió un error al generar el reporte');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
        <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Generador de Reportes
        </Typography>

        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <DatePickerField label={from.label} name={from.name} />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <DatePickerField label={to.label} name={to.name} />
          </Grid>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1" gutterBottom sx={{ mt: 1, mb: 1 }}>
            Tipo de reporte:
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={reportType.excel}
                onChange={handleReportTypeChange}
                name="excel"
                color="primary"
              />
            }
            label="Excel (.xlsx)"
          />
          <FormControlLabel
            control={
              <Checkbox
                disabled={true}
                checked={reportType.pdf}
                onChange={handleReportTypeChange}
                name="pdf"
                color="primary"
              />
            }
            label="PDF (.pdf)"
          />
        </Grid>
      </Paper>
    </>
  );
};
